import styled from "styled-components";

const ProductsListImageWrapper = styled.div`


 width: 100%;
 max-width: 300px;
 
 img{
 object-fit: cover;
 }
`;

const ProductsListDescDetails = styled.div``;

export { ProductsListImageWrapper, ProductsListDescDetails };
